import { TestIdDomain } from 'constants/testIds';

export const dialogsTestIds = {
  getModalTestId: id => `${TestIdDomain.DIALOGS}.modal-${id}`,
};
